import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class NotEmittedStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.NotEmittedStatement;
    }
    visitNode(_sb, _node, _options) {
    }
}

//# sourceMappingURL=NotEmittedStatementCompiler.js.map
